import React, { useState, useEffect } from 'react';
import './Gustos2.css';
import { useConfig } from '../context/ConfigContext';
import useMenuWebSocket from '../hooks/useMenuWebSocket';
import fondoGustos from '../assets/FondoGustos2.webp';
import logoHeladeria from '../assets/heladeria boutique.webp';

const Gustos2 = () => {
    const [categoriesWithFlavors, setCategoriesWithFlavors] = useState([]);
    
    const { config } = useConfig();
    
    // Hook WebSocket para actualizaciones en tiempo real
    const {
        flavorCategories,
        flavors,
        isConnected,
        isLoading,
        error,
        reconnect
    } = useMenuWebSocket(config?.shopBranchId);

    // Procesar datos WebSocket cuando cambien
    useEffect(() => {
        if (flavorCategories.length > 0 && flavors.length > 0) {
            console.log('=== PROCESANDO DATOS WEBSOCKET GUSTOS-2 ===');
            console.log('Categorías WebSocket:', flavorCategories);
            console.log('Gustos WebSocket:', flavors);

            // Filtrar solo elementos activos
            const activeCategories = flavorCategories.filter(category => category.status);
            const activeFlavors = flavors.filter(flavor => flavor.status);

            // Agrupar gustos por categoría
            const categoriesWithFlavorsData = activeCategories.map(category => {
                const categoryFlavors = activeFlavors.filter(flavor => 
                    flavor.flavorCategoryId === category.id
                );
                return {
                    ...category,
                    flavors: categoryFlavors
                };
            }).filter(category => category.flavors.length > 0); // Solo categorías con gustos

            console.log('Categorías con gustos procesadas:', categoriesWithFlavorsData);

            // Dividir en 2 grupos para las 2 pantallas
            // Esta es la pantalla 2 - muestra la segunda mitad
            const halfIndex = Math.ceil(categoriesWithFlavorsData.length / 2);
            const secondHalf = categoriesWithFlavorsData.slice(halfIndex);

            console.log('Segunda mitad para gustos-2:', secondHalf);

            setCategoriesWithFlavors(secondHalf);
        }
    }, [flavorCategories, flavors]);



    if (isLoading) {
        return (
            <div 
                className="tv-screen-container"
                style={{
                    backgroundImage: `url(${fondoGustos})`
                }}
            >
                <div className="tv-loading">
                    <div className="loading-spinner"></div>
                    <p>Conectando con el servidor...</p>
                </div>
            </div>
        );
    }

    // Los errores de WebSocket se manejan en consola, no se muestran en pantalla
    // para evitar interrupciones visuales durante microcortes de internet


    return (
        <div 
            className="tv-screen-container"
            style={{
                backgroundImage: `url(${fondoGustos})`
            }}
        >
            {/* Indicador discreto de estado de conexión */}
            {!isConnected && (
                <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    background: 'rgba(255, 0, 0, 0.8)',
                    color: 'white',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    fontSize: '12px',
                    zIndex: 1000,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px'
                }}>
                    <div style={{
                        width: '8px',
                        height: '8px',
                        background: 'white',
                        borderRadius: '50%',
                        animation: 'pulse 1s infinite'
                    }}></div>
                    Reconectando...
                </div>
            )}
            
            <div className="tv-header">
                <img src={logoHeladeria} alt="Heladería Boutique" className="tv-logo" />
                <div className="divider-line"></div>
            </div>
            <div className="tv-content">
                {categoriesWithFlavors.length === 0 ? (
                    <div className="tv-empty">
                        <p>No hay gustos disponibles</p>
                    </div>
                ) : (
                    <div className="categories-list">
                        {categoriesWithFlavors.map((category) => (
                            <div key={category.id} className="category-group">
                                <h2 className="category-name">{category.name}</h2>
                                {category.flavors.map((flavor) => (
                                    <div key={flavor.id} className="flavor-name">
                                        {flavor.name}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Gustos2;